import React, { FC } from 'react';

export const LoadingScreen: FC = (): JSX.Element => (
  <div className="container mt-5" style={{ minHeight: '85vh' }}>
    <div className="row justify-content-center">
      <div className="lds-dual-ring"/>
    </div>
  </div>
);